var link_viewer_default = {
  "fontElementMap": "ebI7u",
  "link": "CUBeV",
  "linkInEditor": "EKpTW",
  "linkInViewer": "_2xrqk",
  "toolbarUrlContainer": "G10oR",
  "toolbarUrl": "lOqba",
  "toolbarUrlAnchor": "Ux96i"
};
export {
  link_viewer_default as default
};
//# sourceMappingURL=link-viewer-scss.js.map
